import store from "../../Store/configureStore";
import {
  getInflateAdjustedSystemCostMinBreakIn,
  getInflateAdjustedSystemCostMaxBreakIn,
} from "./costAdjustCalculations";
const lodash = require("lodash");

export const getTotalBenefits = () => {
  const state = store.getState();
  //const inflationRate = parseFloat(lodash.get(state, "costs.costAdjustDetails.inflation-rate"));

  let autoCodingSaving = parseFloat(lodash.get(state, "benefits.benefitsDetails.auto-coding"));
  //1.Auto-coding:

  let vendorCostSaving = parseFloat(lodash.get(state, "benefits.benefitsDetails.vendor-costs-savings"));
  //2. Vendor costs savings:

  let travelSaving = parseFloat(lodash.get(state, "benefits.benefitsDetails.travel-saving"));
  //3. Travel, accommodation, and resource savings:

  let accurateBillingSaving = parseFloat(lodash.get(state, "benefits.benefitsDetails.accurate-billing-saving"));
  //4. Accurate Billing for Procedures:

  let reducedClaimsSavings = parseFloat(lodash.get(state, "benefits.benefitsDetails.reduced-claims-savings"));
  //5. Reduction in miscoded reimbursement claims:

  let otherSavings = parseFloat(lodash.get(state, "benefits.benefitsDetails.other-savings"));
  //6.Additional Benefits:

  if (!autoCodingSaving || autoCodingSaving < 0) {
    autoCodingSaving = 0;
  }

  if (!vendorCostSaving || vendorCostSaving < 0) {
    vendorCostSaving = 0;
  }

  if (!travelSaving || travelSaving < 0) {
    travelSaving = 0;
  }

  if (!accurateBillingSaving || accurateBillingSaving < 0) {
    accurateBillingSaving = 0;
  }

  if (!reducedClaimsSavings || reducedClaimsSavings < 0) {
    reducedClaimsSavings = 0;
  }

  if (!otherSavings || otherSavings < 0) {
    otherSavings = 0;
  }

  return (
    autoCodingSaving + vendorCostSaving + travelSaving + accurateBillingSaving + reducedClaimsSavings + otherSavings
  );
};

export const getCostSavingsMinBreakIn = () => {
  return getInflateAdjustedSystemCostMinBreakIn() - getTotalBenefits();
};

export const getCostSavingsMaxBreakIn = () => {
  return getInflateAdjustedSystemCostMaxBreakIn() - getTotalBenefits();
};
